import {alpha} from "@mui/material/styles";
import {VARIANTS} from "@ui-seeker/core"

import {COLORS} from "../../../@constants";


const overrideProgressStyles = theme => {
    const rootStyle = (ownerState) => {
        const bufferVariant = ownerState.variant === VARIANTS.BUFFER;

        const defaultStyle = {
            borderRadius: 4,
            '& .MuiLinearProgress-bar': {
                borderRadius: 4,
            },
            ...(bufferVariant && {
                backgroundColor: 'transparent',
            }),
        };

        const colorStyle = Object.values(COLORS).map((color) => ({
            ...(ownerState.color === color && {
                backgroundColor: alpha(theme.palette[color].main, 0.24),
            }),
        }));

        return [...colorStyle, defaultStyle];
    };

    return {
        MuiLinearProgress: {
            styleOverrides: {
                root: ({ ownerState }) => rootStyle(ownerState),
            },
        },
    }
}

export default overrideProgressStyles;